import { FormErrorMessage, FormGroup } from '@ksyos/design-system';
import { Menu, MenuItem } from 'react-bootstrap-typeahead';
import { StyledTypeahead } from '@frontend/components/fields';
import { getValidationErrorTranslation } from '@frontend/utils';

type TextInputTypeAheadProps<T extends string> = {
    disabled?: boolean;
    error?: string;
    label: string;
    onChange: (value: T | null) => void;
    options: T[];
    placeholder?: string;
    value: T | null;
    variant?: 'outline' | 'flushed';
};

export function TextInputTypeAhead<T extends string>(props: Readonly<TextInputTypeAheadProps<T>>) {
    const { disabled, error, label, onChange, options, placeholder, variant } = props;

    return (
        <FormGroup
            isRequired
            label={label}
        >
            <StyledTypeahead
                $hasError={Boolean(error)}
                $variant={variant ?? 'flushed'}
                disabled={disabled}
                id="typeahead"
                key="input"
                onChange={async (selected) => {
                    if (selected.length === 1) {
                        onChange(selected[0] as T);
                    }
                }}
                onInputChange={async (value) => {
                    onChange((value as T) || null);
                }}
                options={options}
                placeholder={placeholder}
                renderMenu={(results, { newSelectionPrefix, paginationText, renderMenuItemChildren, ...menuProps }) => (
                    <Menu {...menuProps}>
                        {results.map((result, index) => (
                            <MenuItem
                                key={`${result}`}
                                option={result}
                                position={index}
                            >
                                {result as string}
                            </MenuItem>
                        ))}
                    </Menu>
                )}
                selected={props.value ? [props.value] : []}
                style={{ width: '100%' }}
            />
            {error && <FormErrorMessage>{getValidationErrorTranslation(error)}</FormErrorMessage>}
        </FormGroup>
    );
}
